import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { STATUS_OPTIONS } from '../constants';
import { getStatus } from '../utils';

const StatusSelect = ({ value, onChange, sx }) => {
  const status = getStatus(value);

  return (
    <Select
      size="small"
      value={value || 'pending'}
      onChange={(e) => onChange(e.target.value)}
      sx={{
        fontSize: '0.75rem',
        fontWeight: 700,
        borderRadius: '6px',
        bgcolor: status.bg,
        color: status.color,
        '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
        '& .MuiSvgIcon-root': { color: status.color },
        ...sx,
      }}
    >
      {STATUS_OPTIONS.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default StatusSelect;
